import { tv } from 'tailwind-variants'

export const checkboxClassName = tv({
  slots: {
    container: 'flex items-center gap-2',
    label: 'body-small-basic text-neutral-primary',
    defaultLabel: 'h-6',
    errorMessage: 'text-xs text-status-critical',
  },
  variants: {
    variant: {
      default: {
        container: '',
      },
      outlined: {
        container: 'border py-2 px-4 border-neutral-10 rounded-xl cursor-pointer',
      },
    },
    fillBgWhenChecked: { true: {} },
    checked: { true: {}, indeterminate: {} },
    disabled: {
      true: {
        label: 'text-neutral-disabled',
      },
    },
    hasId: {
      true: {
        defaultLabel: 'cursor-pointer',
      },
    },
  },
  compoundVariants: [
    {
      variant: 'outlined',
      fillBgWhenChecked: true,
      checked: true,
      class: {
        container: 'bg-button-subtle-pressed',
      },
    },
  ],
  defaultVariants: {
    variant: 'default',
  },
})
